import { z } from "zod";

export const successResponseSchema = z.object({
  success: z.literal(true),
  code: z.string(),
  message: z.string(),
  data: z.unknown().optional(),
  meta: z.unknown().optional(),
});

export const failureResponseSchema = z.object({
  success: z.literal(false),
  code: z.string(),
  message: z.string(),
  data: z.unknown().optional(),
});

export type SuccessResponseDto = z.infer<typeof successResponseSchema>;
export type FailureResponseDto = z.infer<typeof failureResponseSchema>;
